export const userRightsData = [
   {
      dashboard: {
         roleId: 40,
         roleName: 'Dashboard',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      masters: {
         roleId: 1,
         roleName: 'Masters',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      customer: {
         roleId: 2,
         roleName: 'Customer',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      vendor: {
         roleId: 3,
         roleName: 'Vendor',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      AllAccount: {
         roleId: 41,
         roleName: 'All Account',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      item: {
         roleId: 4,
         roleName: 'Item',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      category: {
         roleId: 5,
         roleName: 'Category',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      brand: {
         roleId: 6,
         roleName: 'Brand',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      series: {
         roleId: 7,
         roleName: 'Series',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      itemGroup: {
         roleId: 8,
         roleName: 'Item Group',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      warehouse: {
         roleId: 9,
         roleName: 'Warehouse',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      unit: {
         roleId: 10,
         roleName: 'Unit',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      screen: {
         roleId: 11,
         roleName: 'Screen',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 4,
      },
      ledger: {
         roleId: 12,
         roleName: 'Ledger',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      daybook: {
         roleId: 13,
         roleName: 'Daybook',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      billtterm: {
         roleId: 14,
         roleName: 'Bill Term',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 13,
      },
      bankbranch: {
         roleId: 15,
         roleName: 'Bank Branch',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      transport: {
         roleId: 16,
         roleName: 'Transport',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      driver: {
         roleId: 17,
         roleName: 'Driver',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 16,
      },
      vehicle: {
         roleId: 18,
         roleName: 'Vehicle',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 16,
      },
      other: {
         roleId: 19,
         roleName: 'Other',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 1,
      },
      color: {
         roleId: 20,
         roleName: 'Color',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      salerepresentative: {
         roleId: 21,
         roleName: 'Driver',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      style: {
         roleId: 22,
         roleName: 'Style',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      size: {
         roleId: 23,
         roleName: 'Size',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      hsn: {
         roleId: 24,
         roleName: 'HSN',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      countries: {
         roleId: 25,
         roleName: 'Countries',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      states: {
         roleId: 26,
         roleName: 'States',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      city: {
         roleId: 27,
         roleName: 'City',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      Area: {
         roleId: 46,
         roleName: 'Area',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 19,
      },
      sale: {
         roleId: 28,
         roleName: 'Sale',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      saleinvoice: {
         roleId: 29,
         roleName: 'Sale Invoice',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 28,
      },
      salereturn: {
         roleId: 30,
         roleName: 'Sale Return',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 28,
      },
      salechallan: {
         roleId: 51,
         roleName: 'Sale Challan',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 28,
      },
      saleorder: {
         roleId: 52,
         roleName: 'Sale Order',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 28,
      },
      purchase: {
         roleId: 31,
         roleName: 'Purchase',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      purchaseinvoice: {
         roleId: 32,
         roleName: 'Purchase Invoice',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 31,
      },
      purchasereturn: {
         roleId: 33,
         roleName: 'Purchase Return',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 31,
      },
      purchasechallan: {
         roleId: 53,
         roleName: 'Purchase Challan',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 31,
      },
      purchaseorder: {
         roleId: 54,
         roleName: 'Purchase Order',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 31,
      },
      inventory: {
         roleId: 42,
         roleName: 'Inventory',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      inventoryissue: {
         roleId: 43,
         roleName: 'Issue',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 42,
      },
      inventoryreceive: {
         roleId: 44,
         roleName: 'Receive',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 42,
      },
      inventorystocktransfer: {
         roleId: 45,
         roleName: 'Stock Transfer',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 42,
      },
      cash: {
         roleId: 34,
         roleName: 'Cash',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      cashReceive: {
         roleId: 47,
         roleName: 'Cash Receive',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 34,
      },
      cashPayment: {
         roleId: 48,
         roleName: 'Cash Payment',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 34,
      },
      bank: {
         roleId: 35,
         roleName: 'Bank',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      bankReceive: {
         roleId: 49,
         roleName: 'Bank Receive',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 35,
      },
      bankPayment: {
         roleId: 50,
         roleName: 'Bank Payment',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: 35,
      },
      journalvouchers: {
         roleId: 36,
         roleName: 'Journal Vouchers',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      reports: {
         roleId: 37,
         roleName: 'Reports',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      Profile: {
         roleId: 38,
         roleName: 'Profile',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
      companyprofile: {
         roleId: 39,
         roleName: 'Company Profile',
         add: false,
         edit: false,
         deleteRole: false,
         print: false,
         view: false,
         parentroleId: null,
      },
   },
];

export const viewJson = [
   {
      companyId: 3,
      dashboardView: true,
      dashboard: {
         topSales: true,
         topPurchase: true,
         rojmel: true,
         bankAccounts: true,
         whatsNew: true,
         monthlySales: true,
         monthlyPurchases: true,
         quarterlySales: true,
         quarterlyPurchase: true,
         growthRate: true,
         totalSaleVsPurchase: true,
         weeklySalesPerformance: true,
         topCustomerPerformance: true,
         movingAverageTrends: true,
         profitabilityByCustomer: true,
         cashFlowAnalysis: true,
         transactionSizeDistribution: true,
         agingAnalysis: true,
         heatmapMetrics: true,
         yearOverYearSalesComparison: true,
         cityWiseSalesAnalysis: true,
         weeklyPerformanceTrends: true,
         customerSalesDistribution: true,
         accountsReceivableAndPayable: true,
         exceptionReportingAnalysis: true,
      },
      customer: {
         name: true,
         address: false,
         city: false,
         state: false,
         country: false,
         pincpde: false,
         mobile: true,
         panNo: false,
         email: false,
         gstRegNo: true,
         createdU: false,
         ledger: false,
         amt: true,
         status: false,
      },
      vendor: {
         name: true,
         address: false,
         city: false,
         state: false,
         country: false,
         pincpde: false,
         mobile: true,
         panNo: false,
         email: false,
         gstRegNo: true,
         createdU: false,
         ledger: false,
         amt: true,
         status: false,
      },
      account: {
         name: true,
         address: false,
         city: false,
         state: false,
         country: false,
         pincpde: false,
         mobile: true,
         panNo: false,
         email: false,
         gstRegNo: true,
         createdU: false,
         ledger: false,
         amt: true,
         status: false,
      },
      item: {
         name: true,
         barcode: false,
         itemGroupName: true,
         stock: true,
         uqc1Data: true,
         uqc2Data: false,
         uqc3Data: false,
         peimaryUqcData: false,
         sales: false,
         purchaseReport: false,
         hsn: true,
         gstPer: false,
      },
      daybook: {
         name: true,
         typeName: true,
         subTypeName: false,
         accountNo: false,
         accountName: true,
         termsNCondition: false,
         autoRoundOffAtName: false,
         methodOfRounedLiName: false,
         issueDaybookName: false,
         isOld: false,
         status: true,
      },
      sales: {
         docNo: true,
         billDate: true,
         item: true,
         serialNo: true,
         daybook: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         taxableAmount: true,
         gst: true,
         netAmount: true,
         pendingAmount: true,
         paymentStatus: true,
         createdU: false,
         updatedU: false,
         status: false,
      },
      salesReturn: {
         docNo: true,
         billDate: true,
         item: true,
         serialNo: true,
         daybook: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         taxableAmount: true,
         gst: true,
         netAmount: true,
         pendingAmount: true,
         paymentStatus: true,
         createdU: false,
         updatedU: false,
         status: false,
      },
      purchase: {
         docNo: true,
         docDate: true,
         partyDate: true,
         daybook: true,
         Item: true,
         serialNo: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         taxableAmount: true,
         gst: true,
         netAmount: true,
         pendingAmount: true,
         paymentStatus: true,
         createdU: false,
         updatedU: false,
         status: false,
      },
      purchaseReturn: {
         docNo: true,
         docDate: true,
         daybook: true,
         Item: true,
         serialNo: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         taxableAmount: true,
         gst: true,
         netAmount: true,
         pendingAmount: true,
         paymentStatus: true,
         createdU: false,
         updatedU: false,
         status: false,
      },
      issue: {
         docNo: true,
         docDate: true,
         daybook: true,
         Item: true,
         serialNo: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         taxableAmount: true,
         gst: true,
         netAmount: true,
         pendingAmount: true,
         createdU: true,
         updatedU: true,
         status: false,
      },
      receive: {
         docNo: true,
         docDate: true,
         daybook: true,
         Item: true,
         serialNo: true,
         party: true,
         qty1: false,
         qty2: false,
         qty3: false,
         createdU: true,
         updatedU: true,
         status: true,
      },
      cash: {
         txnDate: true,
         docNumber: true,
         accountName: true,
         amount: true,
         bankName: true,
         transactionNo: true,
         status: true,
      },
      bank: {
         txnDate: true,
         docNumber: true,
         accountName: true,
         amount: true,
         bankName: true,
         transactionNo: true,
         createdu: true,
         status: true,
      },
      journalVoucher: {
         docNumber: true,
         txnDate: true,
         daybookname: true,
         notes: true,
         total_amount: true,
      },
   },
];
